import { isTerminalAdmissionReadiness } from './selectors';

export const admissionPollConfig = {
  intervalMs: 1500,
  maxAttempts: 20,
};

function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

/**
 * Poll GET package admission until readiness leaves EVALUATING.
 * Uses the existing fetch function; does not add a second event system.
 */
export async function waitForAdmissionEvaluation(fetchAdmission, options = {}) {
  const intervalMs = options.intervalMs ?? admissionPollConfig.intervalMs;
  const maxAttempts = options.maxAttempts ?? admissionPollConfig.maxAttempts;
  let latest = await fetchAdmission();
  let attempts = 0;
  while (!isTerminalAdmissionReadiness(latest?.readiness_status) && attempts < maxAttempts) {
    await delay(intervalMs);
    latest = await fetchAdmission();
    attempts += 1;
  }
  return latest;
}
